import WellLocation from './WellLocation';

export default WellLocation;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellLocation/index.tsx